import {IComponentOptions} from 'angular';
import TSGenossenschaft from '../../../models/TSGenossenschaft';

declare let require: any;
declare let angular: any;

export class GenossenschaftComponentConfig implements IComponentOptions {
    transclude = false;
    bindings: any = {
        model: '=',
        name: '@',
        angabe: '@',
        zweitperson: '<',
        gesellschaft: '<',
        onSteuerpflichtChanged: '&',
    };
    template = require('./dv-genossenschaft.html');
    controller = DvGenossenschaftController;
    controllerAs = 'vm';
    require: any = {parentForm: '?^form'};
}

export class DvGenossenschaftController {

    model?: TSGenossenschaft;
    name: string;
    angabe: string;
    zweitperson: boolean;
    gesellschaft: boolean;
    onSteuerpflichtChanged: (paramObj: any) => void;

    public getModel(): TSGenossenschaft | undefined {
        return this.model;
    }

    getName(): string {
        if (this.gesellschaft) {
            return 'GESELLSCHAFT_NAME';
        } else {
            return 'GENOSSENSCHAFT_NAME';
        }
    }

    getSteuerpflichtName(): string {
        if (this.gesellschaft) {
            return 'STEUERPFLICHT_GESELLSCHAFT';
        } else {
            return 'STEUERPFLICHT_GENOSSENSCHAFT';
        }
    }

    getNichtSteuerpflichtName(): string {
        if (this.gesellschaft) {
            return 'NICHT_STEUERPFLICHT_GESELLSCHAFT';
        } else {
            return 'NICHT_STEUERPFLICHT_GENOSSENSCHAFT';
        }
    }

    private steuerpflichtChanged(event: any) {
        this.onSteuerpflichtChanged({event: event})
    }
}




// WEBPACK FOOTER //
// ./src/app/core/component/dv-genossenschaft/dv-genossenschaft.ts